import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnInit,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'sd-button',
  templateUrl: './button.component.html',
  styleUrls: [
    './button.component.scss',
  ]
})

export class ButtonComponent implements OnInit, AfterViewInit {
  private pDisabled = false;
  private initialized = false;
  isDisabled = false;
  @Input() color: 'primary' | 'accent' | 'warn' | 'secondary' | 'tertiary' | 'positive' | 'negative' | undefined = undefined;
  @Input() title: string;
  @Input() icon: string;
  @Input() width: string;
  @Input() size: 'sm' | 'lg';
  @Input() tooltip: string;
  @Input() iconSuffix = false;
  @Input() fontSet: 'material-icons' |
    'material-icons-outlined' |
    'material-icons-outlined' |
    'material-icons-round' |
    'material-icons-sharp' = 'material-icons';
  @Input() set disabled(value: boolean) {
    this.pDisabled = value || false;
    if (this.initialized) {
      this.onChanges();
    }
  }
  @Input() loading = false;
  @Output() action = new EventEmitter();

  constructor(private ref: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.onChanges();
    this.initialized = true;
  }

  private onChanges() {
    this.isDisabled = this.pDisabled;
    this.ref.detectChanges();
  }

  onClick = ($event: any) => {
    if (this.loading) {
      return;
    }
    this.action.emit($event);
  }
}
